import Watermark from './Watermark';

export default Watermark;
